<template>
  <el-dialog title="业务关闭" :close-on-click-modal="false" :visible.sync="visible" width="600px" @close="onReset">
    <div class="py-2">确认关闭车牌 {{ license_plate }}，预约记录为 {{ booking_code }}  ，重量：{{weight}}T的记录吗？</div>
    <el-form ref="form" :model="form" :rules="rules" label-width="6em">
      <el-form-item label="磅单号" prop="pound_code">
        <el-input v-if="weight_type === '1'" v-model.trim="form.pound_code"></el-input>
        <template v-if="weight_type === '2'">
          {{ form.pound_code || '--' }}
        </template>
      </el-form-item>
      <el-form-item label="关闭原因" prop="close_reason">
        <el-input :autosize="{ minRows: 4, maxRows: 8 }" placeholder="请输入原因" type="textarea"
          v-model="form.close_reason"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { debounce } from 'lodash';
export default {
  data() {
    return {
      visible: false,
      weight_type: "0",
      weight: "0",
      license_plate: "",
      booking_code: "",
      form: {},
      rules: {
        pound_code: [
          { 
            required: true, 
            message: "请输入磅单号", 
            trigger: "change"
          },
          { pattern: /^[A-Z0-9]*$/, message: '磅单号只能包含大写字母或数字', trigger: 'change' }
        ],
        close_reason: [
          { required: true, message: "请输入关闭原因", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    onConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$confirm(`请再次确认，${this.license_plate}，预约记录为 ${this.booking_code} 的磅单号修改为：${this.form.pound_code}`, "提示").then(() => {
            this.handleCloseBookingPound();
          });
        }
      });
    },
    handleCloseBookingPound: debounce(async function(){
      try {
        await this.$common.http({
          url: "/api/queue/admin/close_booking_pound",
          data: this.form
        });
        this.visible = false;
        this.$emit('ok');
      } catch (error) { }
    }, 300),
    onOpen(row) {
      this.$set(this.form, 'close_reason', row.close_reason);
      this.weight = row.weight;
      this.weight_type = row.weight_type;
      this.booking_code = row.booking_code;
      this.license_plate = row.license_plate;
      this.form.id = row.id;
      if (this.weight_type === "2") {
        this.$set(this.form, 'pound_code', row.pound_code);
      }
      this.visible = true;
    },
    onReset() {
      this.form = {};
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 0 15px 0px !important;
}
</style>
